import React, { useState, useEffect } from "react";
import { getShorthandName } from "../../../../../utils/Helper";
import { Countries } from "../../../../../components/public/Home/CountryFlag";
export const AuthSignItem = ({ data: { Authorized_signID } }) => {
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (Authorized_signID) {
      Countries.filter((county) => {
        if (county.code === Authorized_signID?.nationality) {
          setCountry(county.name);
        }
      });
    }
  }, [Authorized_signID]);

  return (
    <div className="p-4 border min-w-[100%] border-slate rounded-md">
      <div className="flex gap-2 pb-4">
          <div className="w-14 h-14 rounded-full flex items-center justify-center border-4 border-lightGray shadow-md cursor-pointer">
            <span
              className={`text-profile ${getShorthandName(Authorized_signID.name || "").length > 2
                  ? "text-f12"
                  : "text-f14"
                }`}
            >
              {getShorthandName(Authorized_signID.name || "")}
            </span>
          </div>
        <div className="">
          <p className="text-left font-semibold text-f16 pt-2 text-primary">
            {Authorized_signID.name}
          </p>
          <p className="text-left font-light text-f14 text-secondarytwo">
            {Authorized_signID.designation}
          </p>
        </div>
      </div>
      <hr />
      {Authorized_signID?.work_email && (
        <div className="text-f16 text-primary text-left py-2">
          <span className="text-secondary text-f12">Work Email Address</span>
          <br />
          <span className="truncate text-clip text-[14px]">
            {Authorized_signID?.work_email}
          </span>
        </div>
      )}
      {Authorized_signID?.work_mobile && (
        <div className="text-[12px] sm: text-primary text-left py-2">
          <span className="text-secondary text-f12">Work Mobile Number</span>
          <br />
          <span className="text-[14px]">{Authorized_signID?.work_mobile?.replace("|", "")}</span>
        </div>
      )}
      {Authorized_signID?.nationality && (
        <div className="text-[12px] sm: text-primary text-left py-2">
          <span className="text-secondary text-f12">Nationality</span>
          <br />
          <span className="text-[14px]">{country}</span>
        </div>
      )}
    </div>
  );
};
